import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconUnpin({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="m.807.605.047.042 14.5 14.499a.5.5 0 0 1-.661.75l-.047-.043L.146 1.354a.5.5 0 0 1 .661-.75zm1.135 3.543a.5.5 0 0 1-.003.708 1.5 1.5 0 0 0-.066 2.048l.068.071L9.02 14.06c.585.585 1.54.585 2.125 0a.5.5 0 0 1 .708.708 2.507 2.507 0 0 1-3.451.086l-.09-.086-3.196-3.2a.514.514 0 0 1-.063.103l-.043.049-4.129 4.129a.516.516 0 0 1-.773-.681l.043-.05 4.13-4.128a.514.514 0 0 1 .15-.105l-3.197-3.2a2.501 2.501 0 0 1 0-3.54.5.5 0 0 1 .708.003zM12.26.662l.093.088 2.897 2.897c.97.97 1 2.53.088 3.535l-.088.092-2.897 2.897a.516.516 0 0 1-.773-.68l.043-.05 2.897-2.897a1.536 1.536 0 0 0 .069-2.093l-.069-.074-2.897-2.897a1.536 1.536 0 0 0-2.094-.069l-.073.069-1.043 1.042 2.79 2.79a.516.516 0 0 1-.68.773l-.05-.043-2.79-2.791-1.124 1.126a.516.516 0 0 1-.773-.681l.043-.049L8.726.75c.97-.97 2.529-1 3.534-.088z"/>
        </svg>

    );
}

export default IconUnpin;

